// LC Client actions that we're stealing
import {
  // preload middleware
  LOAD_MACMILLAN_SUCCESS,
  // activity flow and control
  ACTIVITY_SUCCESS,
  LOAD_ACTIVITY_COMPLETION_TIME_SUCCESS,
  LOAD_ACTIVITY_COMPLETION_TIME_FAILURE,
  LOAD_PROGRESS_SUCCESS,
  TIPS_FOR_SUCCESS,
  CLOSE_TIPS_FOR_SUCCESS,
  FAQ,
  SAVE_PROGRESS_SUCCESS,
  CLOSE_NETWORK_ISSUE_MODAL,
  SHOW_NETWORK_ISSUE_MODAL
} from '../../client/actions'

import {
  defaultState
} from '../../client/reducers/reducerHelpers'

import { handlePreviewAction } from '../lib/handlePreviewAction'
import { calculateCourseDashboardData, constructRosterObjects } from '../../client/lib/macmillan'

import {
  ASSIGNMENT_READING,
  LOAD_LCRP_DATA,
  OPEN_CHECK_UNDERSTANDING,
  CLOSE_CHECK_UNDERSTANDING,
  CHECK_ANSWER,
  FETCH_QUESTION,
  LCRP_PROGRESS_SUCCESS,
  LCRP_PROGRESS_FAILURE,
  LCRP_GET_ALL_ACTIVITIES_SUCCESS,
  READING_SELECTED,
  CYU_READING_SELECTED,
  START_QUIZ,
  PREVIEW_MODE,
  FIRST_ATTEMPT_COMPLETE,
  ADDITIONAL_ATTEMPT_COMPLETE
} from '../actions'

// runs anything related to parameters passed through the query string
import { query } from '../lib/queryHooks'
import { simulateDemoUser, simulateDemoProgress } from '../lib/demoData'
import { buildRetake, buildLiveRetakeCheck, resetQuestionViewData } from '../lib/retake'
import { resetRetake, populateDefaultLCRPProgress, isRetakeComplete, isInProgressCheck } from '../lib/parse'
import { checkAnswer } from '../lib/checkUnderstanding'
import _ from 'lodash'

import clientCore, { mergeQuestionViewData } from '../../client/reducers/core'

import { ACTION_CALL_TIME } from '../../client/middleware/timing'

import params from '../../client/lib/params'
const { isInstructorView } = params(window.location.href)

const lcrpDefaultState = {
  ...defaultState,
  ...{
    activity: { lcrp: {} }
  }
}

// core reducer
export default function core (state = lcrpDefaultState, action) {
  const { type, response, payload } = action
  let activity, uiState

  switch (type) {
    case LOAD_MACMILLAN_SUCCESS: {
      const thisResponse = response
      state.initialUserData = thisResponse
      state.config = action.config
      uiState = _.cloneDeep(state.uiState)
      return { ...state, uiState }
    }
    case ACTIVITY_SUCCESS: {
      /* This case will be hit from the following: LCRP InstructorPage load, AssignmentReading from
       * a normal non-instructor LCRP load, from LCRP InstructorPage preview mode load, and from
       * LCRP InstructorPage URL preview mode load. Due to the order these calls happen, the
       * activity state could be reset by a repeated call. This should be revised,
       * but the following one line change was a simple workable solution. The showAssignmentReading state in this
       * case will only be set to true before the return statement if it was previously set
       * or if simulateData exists in the URL
      */
      activity = isInstructorView && state.activity.score ? _.cloneDeep(state.activity) : action.payload
      activity.lcrp = _.cloneDeep(state.activity.lcrp)
      const simulateValue = query.simulateData || '-1'
      if (query.demo) {
        Object.assign(activity, simulateDemoUser(activity, query.demo))
      }

      if (activity.lcrp.progress === undefined) {
        // run any hooks associated with query parameters
        Object.assign(activity, handlePreviewAction(activity, simulateValue))

        if (activity.lcrp.progress === undefined) {
          Object.assign(activity, populateDefaultLCRPProgress(activity))
        }
      }
      uiState = _.cloneDeep(state.uiState)
      uiState.showAssignmentReading = uiState.showAssignmentReading || simulateValue !== '-1'
      return { ...state, activity, uiState }
    }
    case ASSIGNMENT_READING:
      uiState = _.cloneDeep(state.uiState)
      uiState.showAssignmentReading = true
      return { ...state, uiState }
    case OPEN_CHECK_UNDERSTANDING:
      uiState = _.cloneDeep(state.uiState)
      uiState.showCheckYourUnderstandingModal = true
      return { ...state, uiState }
    case CLOSE_CHECK_UNDERSTANDING:
      activity = _.cloneDeep(state.activity)
      uiState = _.cloneDeep(state.uiState)
      uiState.showCheckYourUnderstandingModal = false
      return { ...state, activity, uiState }
    case TIPS_FOR_SUCCESS:
      uiState = _.cloneDeep(state.uiState)
      uiState.isTipsForSuccessModalDisplayed = true
      return { ...state, uiState }
    case CLOSE_TIPS_FOR_SUCCESS:
      uiState = _.cloneDeep(state.uiState)
      uiState.isTipsForSuccessModalDisplayed = false
      return { ...state, uiState }
    case FAQ:
      uiState = _.cloneDeep(state.uiState)
      uiState.showFaqPage = !uiState.showFaqPage
      uiState.isTipsForSuccessModalDisplayed = false
      return { ...state, uiState }
    case SHOW_NETWORK_ISSUE_MODAL:
      uiState = _.cloneDeep(state.uiState)
      uiState.isShowNetworkIssueModalDisplayed = true
      return { ...state, uiState }
    case CLOSE_NETWORK_ISSUE_MODAL:
      uiState = _.cloneDeep(state.uiState)
      uiState.isShowNetworkIssueModalDisplayed = false
      return { ...state, uiState }
    case FETCH_QUESTION:
      activity = _.cloneDeep(state.activity)
      activity.score.curCard = action.payload
      return { ...state, activity }
    case CHECK_ANSWER: {
      activity = _.cloneDeep(state.activity)
      uiState = _.cloneDeep(state.uiState)

      const answerSelected = action.payload.answerSelected
      const selectedSection = action.payload.selectedSection

      activity.score.curCard.userAnswerIndex = parseInt(answerSelected, 10)

      const isCorrect = checkAnswer(activity.score)
      if (isCorrect) {
        if (isRetakeComplete(activity)) {
          activity.lcrp.progress.rt[`${selectedSection.sectionId}`].cyuC.push(action.payload.cyuIndex)
        } else {
          activity.lcrp.progress.fa[`${selectedSection.sectionId}`].cyuC.push(action.payload.cyuIndex)
        }
      }

      return { ...state, activity, uiState }
    }
    case LOAD_LCRP_DATA:
      activity = _.cloneDeep(state.activity)
      buildRetake(activity, 0, 1)
      simulateDemoProgress(activity, action.value)
      return { ...state, activity }
    case LCRP_PROGRESS_SUCCESS: {
      activity = _.cloneDeep(state.activity)
      if ((activity.config !== undefined && activity.config.isInstructorView !== undefined &&
        activity.config.isInstructorView === true) ||
        (activity.config !== undefined && activity.config.simulateData !== undefined)) {
        return state
      }
      if (payload.activity_state && (payload.activity_state.fa && payload.activity_state.rt)) {
        activity.lcrp = {
          progress: payload.activity_state
        }
      }
      const dashboardStudent = action.payload.dashboardStudent ? action.payload.dashboardStudent : []
      const rosterObjects = constructRosterObjects(activity, dashboardStudent);
      const courseDashboardData = calculateCourseDashboardData(activity, dashboardStudent)
      activity.courseDashboardData = courseDashboardData
      return { ...state, courseDashboardData, activity }
    }
    case LCRP_PROGRESS_FAILURE: {
      activity = _.cloneDeep(state.activity)
      const emptyData = calculateCourseDashboardData(activity, [])
      state.courseDashboardData = emptyData
      activity.courseDashboardData = emptyData
      return { ...state, activity }
    }
    case LCRP_GET_ALL_ACTIVITIES_SUCCESS: {
      const newState = _.cloneDeep(state)
      newState.courseDashboardData.assignmentOverview = payload
      if (newState.activity.courseDashboardData) {
        newState.activity.courseDashboardData.assignmentOverview = payload
      }
      return newState
    }
    case LOAD_ACTIVITY_COMPLETION_TIME_FAILURE:
      return { ...state }
    case LOAD_ACTIVITY_COMPLETION_TIME_SUCCESS:
      activity = _.cloneDeep(state.activity)
      activity.courseAvgTime = action.payload.avgTime
      activity.courseEstTime = action.payload.estTime
      return { ...state, activity }
    case LOAD_PROGRESS_SUCCESS: {
      const progress = action.payload
      activity = _.cloneDeep(state.activity)
      if ((activity.config !== undefined && activity.config.isInstructorView !== undefined &&
        activity.config.isInstructorView === true) ||
        (activity.config !== undefined && activity.config.simulateData !== undefined)) {
        return state
      }
      uiState = _.cloneDeep(state.uiState)
      if (progress) {
        activity.completedTimestamp = progress.completedTimestamp
        activity.score.activityScore = progress.score || 0
        activity.timeOnTask = progress.timeOnTask
        activity.studentData.activity_questions_received = progress.qr || 0
        activity.studentData.quizTimes = _.get(progress, 'quizTimes', null)

        if (progress.hintCount) {
          activity.score.hintCount = progress.hintCount
        }

        if (progress.completedQuestionCount) {
          activity.studentData.completedQuestionCount = progress.completedQuestionCount
          activity.score.completedQuestionCount = progress.completedQuestionCount
        }

        if (progress.startQuizTime) {
          activity.studentData.startQuizTime = progress.startQuizTime
        }

        if (progress.completeQuizTime) {
          activity.studentData.completeQuizTime = progress.completeQuizTime
        }

        if (progress.tp) {
          for (let i = 0; i < activity.allTopics.length; i++) {
            const t = activity.allTopics[i]
            t.questionsReceived = progress.tp[i].qr
            t.nextLevel = progress.tp[i].nl
            t.totalPointsAvailable = progress.tp[i].pa
            t.totalPointsEarned = progress.tp[i].pe
          }

          for (let i = 0; i < activity.topics.length; i++) {
            const t = activity.topics[i]
            t.questionsReceived = progress.tp[i].qr
            t.nextLevel = progress.tp[i].nl
            t.totalPointsAvailable = progress.tp[i].pa
            t.totalPointsEarned = progress.tp[i].pe
          }
        }

        activity.questions = mergeQuestionViewData(activity.questions, progress.questions)

        buildRetake(activity, progress)

        if (progress.rt) {
          activity.studentData.rt = {
            quizTimes: _.get(progress.rt, 'quizTimes', null),
            hintCount: _.get(progress.rt, 'hintCount', 0)
          }
        }

        if (activity.studentData.isRetake) {
          uiState.isRetake = 1
        }

        if (activity.finalScore && activity.finalScore.activityScore >= activity.finalScore.scoreTarget) {
          activity.finalScore.activityGrade = 100
        }

        if (activity.finalScore && progress.hintCount) {
          activity.finalScore.hintCount = progress.hintCount
          activity.score.hintCount = _.get(progress, 'rt.hintCount', 0)
        }

        if (activity.finalScore && progress.completedQuestionCount) {
          activity.finalScore.completedQuestionCount = progress.completedQuestionCount
          activity.score.completedQuestionCount = _.get(progress, 'rt.completedQuestionCount', 0)
        }
      }
      return { ...state, activity, uiState }
    }
    case SAVE_PROGRESS_SUCCESS: {
      const progress = action.payload
      activity = _.cloneDeep(state.activity)
      activity.timeOnTask = progress.activity_state.timeOnTask
      return { ...state, activity }
    }
    case READING_SELECTED: {
      activity = _.cloneDeep(state.activity)
      uiState = _.cloneDeep(state.uiState)
      const sectionId = action.value.sectionId
      // excluded sectionIds will have '_exc' appended to them. See createSectionArray in lcrp/lib/parse.js
      if (!sectionId.includes('exc')) {
        // need to perform this check in case instructor has modified topics while students were in progress
        if (!activity.lcrp.progress.fa[`${sectionId}`]) {
          activity.lcrp.progress.fa[`${sectionId}`] = {}
        }
        activity.lcrp.progress.fa[`${sectionId}`].rd = true
      }
      // record begin time of activity
      if (uiState.lcrpActivityBeginTimestamp === undefined) {
        uiState.lcrpActivityBeginTimestamp = action[ACTION_CALL_TIME]
      }
      uiState.selectedReadingTimestamp = action[ACTION_CALL_TIME]
      uiState.lastSelectedSectionId = sectionId
      return { ...state, activity, uiState }
    }
    case CYU_READING_SELECTED:
      if (payload.coreObj) {
        state = _.cloneDeep(payload.coreObj)
        uiState = _.cloneDeep(state.uiState)
        uiState.lastSelectedSectionId = payload.section.sectionId
      }
      return { ...state, uiState }
    case START_QUIZ:
      // clear the curCard of any CYU questions that were loaded if not currently in progress
      if (!isInProgressCheck(state.activity)) {
        state.activity.score.curCard = null
        state.activity.score.hint = null
        state.uiState.isIncorrectModalDisplayed = false
        state.uiState.isSuccessModalDisplayed = false
        state.uiState.isCompletedActivityModalDisplayed = false
        state.activity.questions = resetQuestionViewData(state.activity.questions)
      }
      state.activity.startActivity = true

      // if they're starting their retake and they never loaded progress from the DB, rearrange everything for the retake
      buildLiveRetakeCheck(state.activity)

      // reset quiz if we're starting after a completed retake (preserving the data)
      resetRetake(state.activity)

      return state
    case PREVIEW_MODE:
      activity = _.cloneDeep(state.activity)
      activity.lcrp = _.cloneDeep(state.activity.lcrp)
      // reset everything before jumping to next preview mode
      activity.score.activityScore = 0
      activity.score.activityGrade = 0
      activity.finalScore = null
      _.each(activity.topics, (topic, i) => {
        topic.totalPointsAvailable = 0
        topic.totalPointsEarned = 0
      })
      Object.assign(activity, handlePreviewAction(activity, action.value))

      if (activity.lcrp.progress === undefined) {
        Object.assign(activity, populateDefaultLCRPProgress(activity))
      }
      uiState = _.cloneDeep(state.uiState)
      uiState.showAssignmentReading = action.value !== '-1'
      return { ...state, activity, uiState }
    case FIRST_ATTEMPT_COMPLETE:
    case ADDITIONAL_ATTEMPT_COMPLETE:
      activity = _.cloneDeep(state.activity)
      activity.score.curCard.completed = true
      // goofy Mickey Mouse bullshit logic to solve MLLC-1512
      if (!activity.score.curCard.pointsAchieved) {
        activity.score.curCard.pointsAchieved = activity.score.curCard.pointsAvailable
        activity.score.curCard.pointsAvailable = 0
      }
      return { ...state, activity }
    default:
      if (state.activity.startActivity || isInstructorView) {
        if (action.type === 'PAUSE_ACTIVITY') {
          // reset the startActivity in the state; this should be done here to keep client's reducer clean of LCRP
          const isComplete = state.activity.score.activityScore >= state.activity.score.scoreTarget

          if (isComplete) {
            state.activity.startActivity = false
            state.activity.score.initialPointsReductionFactor = 1
            state.activity.score.curCard = null
            if (!state.activity.studentData.isRetake) {
              buildRetake(state.activity, null, true)
            }
          }
        }
        return clientCore(state, action)
      }
      return state
  }
}
